module.exports = __webpack_public_path__ + "img/globe.d1806712.svg";